import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserInfo } from "store/reducers/user";
import store, { RootState } from "store";

interface IInitialState {
  visible: boolean,
  actionData: any,
  profileData: any
}

const initialState: IInitialState = {
  visible: false,
  actionData: {},
  profileData: {}
};

export const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    setVisible: (state, action: PayloadAction<any>) => {
      state.visible = action.payload;
    },
    setProfileData: (state, action: PayloadAction<any>) => {
      state.profileData = Object.assign({}, state.profileData, action.payload);
    },
    setActionData: (state, action: PayloadAction<any>) => {
      state.actionData = action.payload;
    }
  },
});

export const mapProfileVisible = (state: RootState) => state.profile.visible;
export const mapFormModalData = (state: RootState) => state.profile.profileData;
export const mapActionData = (state: RootState) => state.profile.actionData;
export const { setProfileData, setVisible, setActionData } = profileSlice.actions;

export const setFormModalData = (data: any) => {
  const dispatch = store.dispatch;
  dispatch(setProfileData(data))
}

export const setProfileVisible = (visible: boolean, data?: any) => {
  const dispatch = store.dispatch;
  dispatch(setVisible(visible))
  dispatch(setActionData(data || {}))

  // 关闭弹窗，重新获取用户信息
  if (!visible) {
    dispatch(getUserInfo({}));
  }
};

export default profileSlice.reducer;
